/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';

/**
 * 
 * @export
 * @interface UpdateGlossaryTermDTO
 */
export interface UpdateGlossaryTermDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateGlossaryTermDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGlossaryTermDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGlossaryTermDTO
     */
    imageId?: string;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof UpdateGlossaryTermDTO
     */
    links: Array<HTTPLink>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGlossaryTermDTO
     */
    additionalImageIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateGlossaryTermDTO
     */
    id: string;
}

/**
 * Check if a given object implements the UpdateGlossaryTermDTO interface.
 */
export function instanceOfUpdateGlossaryTermDTO(value: object): value is UpdateGlossaryTermDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateGlossaryTermDTOFromJSON(json: any): UpdateGlossaryTermDTO {
    return UpdateGlossaryTermDTOFromJSONTyped(json, false);
}

export function UpdateGlossaryTermDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGlossaryTermDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
        'additionalImageIds': json['additionalImageIds'] == null ? undefined : json['additionalImageIds'],
        'id': json['id'],
    };
}

export function UpdateGlossaryTermDTOToJSON(json: any): UpdateGlossaryTermDTO {
    return UpdateGlossaryTermDTOToJSONTyped(json, false);
}

export function UpdateGlossaryTermDTOToJSONTyped(value?: UpdateGlossaryTermDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
        'additionalImageIds': value['additionalImageIds'],
        'id': value['id'],
    };
}

